<template>
  <div>
    <div class="box">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  components:{
  }
};
</script>
<style scoped>
a {
  text-decoration: none;
}
.box {
  display: flex;
}
</style>
